import { combineReducers } from 'redux';
import email from './email/store/email.reducer';
import phone from './phone/store/phone.reducer';
import emailV2 from './emailV2/store/email.reducer';
import phoneV2 from './phoneV2/store/phone.reducer';

const contactReducer = combineReducers({ email, emailV2, phone, phoneV2 });

export default contactReducer;
